import React, { FC } from 'react';
import PayPalBNPLIsolatedMessage from './PayPalBNPLIsolatedMessage';
import PayPalBNPLMessages from './PayPalBNPLMessages';

type CurrencyType =
  | 'USD'
  | 'GBP'
  | 'EUR';

type PlacementType =
  | 'cart'
  | 'home'
  | 'category'
  | 'product'
  | 'payment';

interface Props {
  amount?: number;
  fractionDigits?: number;
  currency?: CurrencyType;
  placement?: PlacementType;
  style?: any;
  classNames?: string;
}

const PayPalBNPLMessaging: FC<Props> = (props) => {
  // Resolve placement first so that omitting it defaults to 'product' (PDP).
  // The old guard ran before defaulting, causing undefined placement to return null
  // and breaking any caller that relied on the optional prop for PDP rendering.
  const { placement: placementProp, ...rest } = props;
  const placement: PlacementType = placementProp === 'cart' ? 'cart' : 'product';

  // Only render on PDP (product) and Cart pages.
  if (placement !== 'product' && placement !== 'cart') return null;

  // The cart page and the cart flyout both load Braintree's PayPal SDK for express checkout, which
  // takes ownership of PayPal in that window and stops the messaging SDK re-rendering at a new
  // amount — a quantity change left the banner showing the old figure. Those placements render the
  // message inside their own iframe instead; see PayPalBNPLIsolatedMessage for the full findings.
  // The PDP has no Braintree SDK, so it keeps the cheaper direct render.
  if (placement === 'cart') {
    return <PayPalBNPLIsolatedMessage {...rest} placement="cart" />;
  }

  return <PayPalBNPLMessages {...rest} placement={placement} />;
};

export default PayPalBNPLMessaging;